import { Text } from '@interco/inter-ui/components/Text'

import * as S from './style'

type Content = {
  title: string
  description: string
}

const AboutContent: Content[] = [
  {
    title: 'O que é o Open Finance?',
    description: `É uma iniciativa do Banco Central que permite transações ou compartilhamento seguro de dados entre instituições financeiras. É preciso autorização da pessoa titular das contas.`,
  },
]

export const AboutOpenFinance = () => (
  <S.Container>
    {AboutContent.map((content) => (
      <S.Content key={content.title}>
        <Text variant="body-1" bold colorWeight={500} style={{ fontSize: 18 }}>
          {content.title}
        </Text>
        <Text variant="body-2" style={{ fontSize: 14 }}>
          {content.description}
        </Text>
      </S.Content>
    ))}
  </S.Container>
)
